// extracted by mini-css-extract-plugin
module.exports = {"questions":"faq-block-module--questions--ABmCL","question":"faq-block-module--question--11OT6","answer":"faq-block-module--answer--1T_R3"};